var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"TheHeader"},[_c('div',{staticClass:"TheHeader__inner container"},[_c('WarrenLogo',{staticClass:"TheHeader__logo",attrs:{"aria-label":"Warren Challenge"}}),_c('ThemeSwitcher')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }